export const CREATOR_MEMBERSHIP_MAX_FREE_TIERS = 1;
export const CREATOR_MEMBERSHIP_MAX_PAID_TIERS = 3;
export const CREATOR_MEMBERSHIP_MAX_CAROUSEL_SLIDES = 8;
export const CREATOR_MEMBERSHIP_MAX_POST_IMAGES = 10;
export const CREATOR_MEMBERSHIP_TEASER_MAX_LENGTH = 160;
export const CREATOR_MEMBERSHIP_PUBLIC_BUTTON_MAX_LENGTH = 24;
export const CREATOR_MEMBERSHIP_GRACE_DAYS = 3;

export const CreatorMembershipPostVisibility = {
  EVERYONE: 'everyone',
  FREE_PLUS: 'free_plus',
  TIER_AND_ABOVE: 'tier_and_above',
} as const;

export type CreatorMembershipPostVisibilityValue =
  (typeof CreatorMembershipPostVisibility)[keyof typeof CreatorMembershipPostVisibility];

export const CREATOR_MEMBERSHIP_CHECKOUT_FLOW = 'creator_membership';

export const CreatorMembershipTierBillingType = {
  FREE: 'free',
  PAID: 'paid',
} as const;

export type CreatorMembershipTierBillingTypeValue =
  (typeof CreatorMembershipTierBillingType)[keyof typeof CreatorMembershipTierBillingType];
